import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BUSINESS_ROUTE } from 'data/global';

import './SentryErrorBoundaryFallback.styles.scss';

type SentryErrorBoundaryFallbackProps = {
  className?: string;
};

const SentryErrorBoundaryFallback: React.FC<
  SentryErrorBoundaryFallbackProps
> = (props) => {
  const { className } = props;

  const classes = classNames('sentry-error-boundary-fallback', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{t('somethingWentWrong')}</p>
      <a href={BUSINESS_ROUTE}>{t('goBackToResolve')}</a>
    </div>
  );
};

export default SentryErrorBoundaryFallback;
